import { ErrorHandler, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { DetailBase } from '~/app/open-age/core/structures';
import { AppointmentsService } from '../services';
import { Appointment } from '../models/appointment.model';
import { User } from '../models/user.model';
import * as moment from 'moment-timezone';
import { MatDialog } from '@angular/material';
import { EditAttandanceDialogComponent } from '~/app/open-age-ng/welcome/dialog/edit-attandance/edit-attandance.component';
import { ConfirmDialogComponent } from '~/app/core/components/confirm-dialog/confirm-dialog.component';

export class AppointmentDetailBaseComponent extends DetailBase<Appointment> implements OnInit, OnChanges {
  @Input()
  code: string;

  isExpired = false

  isChanged = false

  ogAppointment: Appointment

  patients: User[];

  @Input()
  readonly = false;

  @Input()
  timeZone: string;

  displayedColumns: string[] = ['name', 'practice', 'prescriber', 'scheduledBy', 'scheduledOn'];

  constructor(
    private api: AppointmentsService,
    private errorHandler: ErrorHandler,
    public dialog: MatDialog,
  ) {
    super({ api, errorHandler });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.init();
  }

  ngOnInit() {
  }

  init() {
    if (this.code === 'new') {
      this.properties = new Appointment();
      return;
    }
    if (this.code) {
      this.get(this.code).subscribe(() => {
        this.ogAppointment = new Appointment(this.properties)
        if (this.properties.status == 'expired' || this.properties.status == 'visited') {
          this.displayedColumns = ['name', 'practice', 'attandance', 'action'];
          this.isExpired = true
        } else {
          this.displayedColumns = ['name', 'practice', 'prescriber', 'scheduledBy', 'scheduledOn'];
          this.isExpired = false
        }
        this.timeZone = this.ogAppointment.timezone.toString()
      });
    }
  }

  getTime(date: Date) {
    return moment(date).tz(this.timeZone).format("h:mm a")
  }

  getDate(date: Date) {
    return moment(date).tz(this.timeZone).format("MM/DD/YYYY")
  }

  viewItem(visitor: {
    user: User,
    meta?: any,
    appointmentId?: String,
    scheduledBy?: User,
    dateCreated?: Date
    attandance?: {
      lastStart?: Date,
      firstStart?: Date,
      lastEnd?: Date,
      duration?: Number,
      isPresent?: Boolean,
      status: String
    }
  }, index: any) {
    const dialogRef = this.dialog.open(EditAttandanceDialogComponent, {
      width: '750px',
    });
    if (!visitor.attandance) {
      visitor['attandance'] = {
        status: 'Absent'
      }
    }
    dialogRef.componentInstance.visitor = visitor
    dialogRef.afterClosed().subscribe((result) => {
      if (result.user) {
        this.isChanged = true
        this.properties.visitors[index] = result
      }
    })
  }

  finalise() {
    let isAttandanceChange = false
    if (this.ogAppointment.visitors.length != this.properties.visitors.length) {
      isAttandanceChange = true
    }
    for (const visitor of this.properties.visitors) {
      let ogVisitor = this.ogAppointment.visitors.find(item => item.user.role.id == visitor.user.role.id)
      if (visitor.attandance && ogVisitor) {
        if (visitor.attandance.status != ogVisitor.attandance.status) {
          isAttandanceChange = true
          break;
        }
        if (!ogVisitor.attandance && visitor.attandance.status) {
          isAttandanceChange = true
          break;
        }
      } else {
        isAttandanceChange = true
        break;
      }
    }
    if (!isAttandanceChange) {
      this.errorHandler.handleError("No changes found.")
      return
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '450px',
    });
    dialogRef.componentInstance.message = `Save Attendance Changes ?`
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isProcessing = true
        this.api.update(`updateAttendance/${this.properties.id}`, this.properties).subscribe(item => {
          this.properties = new Appointment(item)
          this.ogAppointment = new Appointment(item)
          this.isProcessing = false
          this.updated.emit()
        }, err => {
          this.isProcessing = false
        })
      }
    })
  }

}
